import { Component, OnInit, inject } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { Commune, GeoApiService } from '@app/services/geo-api.service';

@Component({
  selector: 'formly-commune-autocomplete',
  standalone: false,
  template: `
  <mat-form-field style="width: 100%;">
    <mat-label>{{props.label}}</mat-label>
    <input matInput
      [matAutocomplete]="auto"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder"
      [formlyAttributes]="field"
      (blur)="onBlur()">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
      <mat-option *ngFor="let commune of suggestions$ | async" [value]="commune">
        {{ commune.nom }}
         <span style="font-size: 0.875rem; line-height: 1.25rem; opacity: 0.7;">
           — {{ commune.departement?.nom || commune.departement?.code }}
           <ng-container *ngIf="commune.codesPostaux?.length"> · {{ commune.codesPostaux[0] }}</ng-container>
         </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
    `
})
export class CommuneAutocompleteType extends FieldType<FieldTypeConfig> implements OnInit {

  api = inject(GeoApiService);
  suggestions$!: Observable<Commune[]>;

  ngOnInit() {
    const minLen = 2;
    const debounce = 250;
    const limit = 10;

    this.suggestions$ = this.formControl.valueChanges.pipe(
      startWith(this.formControl.value),
      map(v => typeof v === 'string' ? v.trim() : (v?.nom ?? '').trim()),
      distinctUntilChanged(),
      debounceTime(debounce),
      switchMap(term => term.length >= minLen ? this.api.searchCommunes(term, limit) : of([])),
    );
  }

  onSelect(c: Commune) {
    if (!c) return;

    this.formControl.setValue(c.nom);
    this.formControl.markAsDirty();

    const targetCtrl = this.form.get('depNaissance');
    targetCtrl?.setValue(c.departement?.code ?? null);
    targetCtrl?.markAsDirty();
  };


  onBlur(): void {
    const v = this.formControl.value;
    if (typeof v === 'string' && !v.trim()) {

      this.formControl.setValue(null);
      this.formControl.markAsDirty();

      const targetCtrl = this.form.get('depNaissance');
      targetCtrl?.setValue("");

    }
  }
}
